export const AuthSideImages = {
  FRAME_24: "https://cufront-assets.s3.amazonaws.com/images/Frame+24.jpg",
  FRAME_16: "https://cufront-assets.s3.amazonaws.com/images/Frame+16.jpg",
  PHONE_FRAME:
    "https://cufront-assets.s3.amazonaws.com/images/Android+Large+-+1.jpg",
};
